/**
 * Swaps the cart's server-rendered suggestion strip for Shopify's own picks.
 *
 * The strip already works before this runs: snippets/jika-cart-upsell.liquid renders a
 * fallback from the socks collection. This only ever REPLACES that with something better.
 * Every failure path returns early and leaves the fallback in place.
 *
 * Why the section ids get rewritten: sections/jika-cart-upsell.liquid is rendered by the
 * Product Recommendations API, so Liquid's product form tag stamps THAT section's id.
 * Left alone, an add would ask Shopify to re-render the wrong section and the cart would
 * not refresh.
 */
class JikaCartUpsell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    this.#load();
  }

  async #load() {
    const url = this.dataset.url;
    const sectionId = this.dataset.sectionId;
    if (!url || !sectionId) return;

    let doc;
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    } catch (error) {
      return;
    }

    const list = doc.querySelector('.jika-upsell__list');
    // No picks, or every pick was filtered out (already in cart / needs a colour chosen):
    // the fallback is strictly better than an empty strip.
    if (!list || !list.querySelector('.jika-upsell__item')) return;

    for (const form of doc.querySelectorAll('product-form-component')) {
      form.dataset.sectionId = sectionId;
    }
    for (const input of doc.querySelectorAll('input[name="section-id"]')) {
      input.value = sectionId;
    }

    const fragment = document.createDocumentFragment();
    const heading = doc.querySelector('.jika-upsell__heading');
    if (heading) fragment.appendChild(heading);
    fragment.appendChild(list);

    this.replaceChildren(fragment);
  }
}

if (!customElements.get('jika-cart-upsell')) {
  customElements.define('jika-cart-upsell', JikaCartUpsell);
}
